import { Messages } from '~/DesignSystem/components/messages'
import { buildMessageClassName } from '~/DesignSystem/components/messages'
import { Skeleton } from '~/DesignSystem/components/skeleton'
import { cn } from '~/DesignSystem/lib/utils'

function MessagesSkeleton() {
  return (
    <Messages>
      <Skeleton className={cn('h-18 w-65', buildMessageClassName({ direction: 'outgoing' }))} />
      <Skeleton className={cn('h-18 w-64', buildMessageClassName({ direction: 'incoming' }))} />
      <Skeleton className={cn('h-18 w-72', buildMessageClassName({ direction: 'outgoing' }))} />
      <Skeleton className={cn('h-18 w-65', buildMessageClassName({ direction: 'outgoing' }))} />
    </Messages>
  )
}

export { MessagesSkeleton }
